export default __webpack_public_path__ + "static/media/keystone.713005cf.png";